import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usd } from "@/components/dash/utils";

const REASON = { take_profit: "Took profit (+20%)", stop_loss: "Stop-loss (-15%)", time_exit: "1 min before close", settled: "Market settled" };

export const TradesTable = ({ trades }) => (
  <section className="card p-5 sm:p-6 fade-up" data-testid="trades-table">
    <h2 className="font-head font-bold text-lg">Practice trade history</h2>
    <p className="text-xs text-slate-400 mt-1">Every bet the bot made, when it got out and why.</p>
    <div className="mt-4 overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="border-[#1A2338] hover:bg-transparent">
            {["Bought", "Side", "Buy", "Sell", "Result", "Why it sold"].map((h) => (
              <TableHead key={h} className="text-[10px] uppercase tracking-widest font-num text-slate-500 whitespace-nowrap">{h}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {trades.map((t) => (
            <TableRow key={t.id} className="border-[#1A2338] hover:bg-[#111A2C] text-xs" data-testid="trade-row">
              <TableCell className="font-num whitespace-nowrap text-slate-400">{new Date(t.entry_time).toLocaleTimeString()}</TableCell>
              <TableCell className={t.side === "Up" ? "text-[#34D399] font-semibold" : "text-[#F87171] font-semibold"}>{t.side.toUpperCase()}</TableCell>
              <TableCell className="font-num">{Math.round(t.entry_price * 100)}¢</TableCell>
              <TableCell className="font-num">{t.exit_price != null ? `${Math.round(t.exit_price * 100)}¢` : "—"}</TableCell>
              <TableCell className={`font-num whitespace-nowrap ${t.pnl > 0 ? "text-[#34D399]" : t.pnl < 0 ? "text-[#F87171]" : "text-slate-400"}`}>
                {t.status === "open" ? "Open" : `${t.pnl >= 0 ? "+" : ""}${usd(t.pnl)}`}
              </TableCell>
              <TableCell className="text-slate-400 whitespace-nowrap">{t.status === "open" ? "Still holding" : REASON[t.exit_reason]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!trades.length && <p className="text-sm text-slate-500 py-6 text-center" data-testid="trades-empty">No trades yet. The bot only bets when it finds a bargain, so it may wait a few windows.</p>}
    </div>
  </section>
);
